import { ModalMapKeys } from 'src/modals/config';

export function getShouldReplace(modalName?: ModalMapKeys) {
  if (!modalName) return false;
  const openedModalName = localStorage.getItem('openedModalName');
  if (!openedModalName) return true;
  return openedModalName === modalName;
}
